module.exports = __webpack_public_path__ + "img/here.5faa541c.svg";